import React from "react";
import EnvtImg from "../../Images/OurWork/4.png";
import SkillsImg from "../../Images/OurWork/health.png";

const WhoWeAre = () => {
  return (
    <section className="px-6 py-10  md:px-16  bg-white flex  flex-col md:flex-row gap-10">
      {/* ***************************** Text Content ***************************** */}
      <div className="w-full lg:w-1/2 space-y-5">
        <p className="text-Orange font-edu-sa text-sm md:text-base font-semibold uppercase">
          Who We Are?
        </p>
        <h2 className=" text-base md:text-3xl font-serif font-bold text-ndlogoBlue leading-snug">
          New Directions Educational & Welfare Society
        </h2>
        <p className="text-mediumGray  text-justify  md:text-base leading-relaxed ">
          Founded in <span className="text-Orange">2010</span>, New Directions
          has adopted a multi-pillar development approach to drive sustainable
          impact across various regions in India. With an active presence in
          <span className="text-Orange">
            {" "}
            Telangana, Andhra Pradesh, Orissa, Assam, Meghalaya, Kerala,
          </span>{" "}
          and internationally among the{" "}
          <span className="text-Orange">
            Indian diaspora in Melbourne and Boston,
          </span>
          the organization has made a significant difference, impacting over{" "}
          <span className="text-Orange"> 20,000</span> lives.
          <br />
          <br />
          Recognized for its dedication and transparency, New Directions is a
          registered{" "}
          <span className="text-Orange">
            {" "}
            Non-Profit Organization (NPO){" "}
          </span>{" "}
          with both NSE and BSE exchanges. It has been entrusted as a{" "}
          <span className="text-Orange">
            Project Implementation Agency (PIA)
          </span>{" "}
          by the Ministry of Rural Development, Government of India. The
          organization’s excellence was further acknowledged in 2023, when it
          received accolades from the Media & Entertainment Skills Council and
          celebrated <span className="text-Orange">Samyuktha Beegala</span>, its
          Co-founder and CEO, as one of the
          <span className="text-Orange"> Women of 2023.</span> Additionally, New
          Directions proudly partners with the National Solar Energy Federation
          of India (NSEFI) to advance green initiatives.
        </p>
      </div>

      {/* ***************************** Image Content ***************************** */}

      <div className="relative w-full lg:w-1/2 hidden lg:flex  justify-end items-center ">
        {/* ***************************** Top Image ***************************** */}
        <div className="relative z-10 md:w-[85%] h-full   rounded-xl overflow-hidden">
          <img
            src={EnvtImg}
            alt="Volunteer Main"
            className="w-full rounded-xl  object-cover"
          />
        </div>

        {/* ***************************** Bottom Image **************************/}
        <div className="absolute z-20 right-32 h-full top-48 md:w-[80%] rounded-xl overflow-hidden">
          <img
            src={SkillsImg}
            alt="Overlapping Volunteers"
            className="w-full  rounded-xl  object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
